import axios from "axios";

export const getTestInfo = async (test_id) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_REPO}/v1/repo_aden/ondemand/skill-test/${test_id}`);
        return response.data.response;
    } catch (error) {
        console.log('error', error)
    }
}

export const postTestForm = async (testId, formData) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_REPO}/v1/repo_aden/ondemand/skill_test/${testId}/questions`, formData);
        return response.data.response;
    } catch (error) {
        console.log('error', error)
    }
}

export const getTestQuestionsOrAnswers = async (token) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_REPO}/v1/repo_aden/ondemand/skill-test/participant/${token}`);
        return response.data.response;
    } catch (error) {
        console.log('error', error)
    }
}

export const postTestAnswers = async (testId, answers) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_REPO}/v1/repo_aden/ondemand/skill-test/participant/${testId}/evaluation`, answers);
        return response.data.response;
    } catch (error) {
        console.log('error', error)
    }
}